Number.prototype.format = function (n, x) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};
export const Utils = {
//   function isZh()
// {
//   return document.documentElement.lang == 'zh';
// }

  getPriceTxt: function (price, isZh) {
    if (typeof price === 'undefined' || price === '') return '';
    return isZh ? (parseFloat(price / 10000) + ' 万美元') : ('$' + parseInt(price).format());
  },

  getPriceUS: function (number, digits) {
    if(typeof number === 'undefined' || number === '') return '';
    return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }


}
